import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap"; // Or use any modal UI you prefer
import AxiosInstance from "../../utils/axiosInstance";
import toast from "react-hot-toast";
const ForgotPassword = ({ open, handleCloseModal }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Email validation regex (basic format validation)
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async () => {
    if (!email) {
      setMessage("Email is required");
      return;
    }

    if (!validateEmail(email)) {
      setMessage("Please enter a valid email address");
      return;
    }

    const payload = { email };
    setLoading(true);
    setMessage("");

    try {
      const response = await AxiosInstance.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_FORGOT_PASSWORD}`,
        payload
      );

      toast.success(
        response?.data?.message ||
          "Reset link sent successfully! Check your email.",
        {
          duration: 8000, // 5000ms = 5 seconds
        }
      );

     
      handleCloseModal();
    } catch (error) {
      // setMessage("Failed to send reset link. Please try again.");
      toast.error(
        error?.message || "Failed to send reset link. Please try again."
      );
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal show={open} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Forgot Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please enter your email to reset your password.</p>
          <input
            type="email"
            placeholder="Email"
            className="form-control mb-3"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {message && <span className="text-danger">{message}</span>}
          <p>Reset link will be sent to your email.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={loading}>
            {loading ? "Sending..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ForgotPassword;
